import React, { FC, useContext, useEffect } from 'react';
import { StyledCurrentLocation } from './CurrentLocation.styles';
import { SyntheticEvent } from 'react';
import { ContentContext } from '../../../index.contexts';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BMap: any;
  }
}

export interface CurrentLocationProps {
  currentLocationHiddenFieldHandler: (data: Record<string, string>) => void;
  inputFieldHandler: (data: string) => void;
}

const CurrentLocationBaidu: FC<CurrentLocationProps> = ({ currentLocationHiddenFieldHandler, inputFieldHandler }) => {
  const { currentLocationLabel } = useContext(ContentContext);
  const { envVarsObject } = useClientEnvVarsStore();

  const getCurrentLocationBaidu = (callback: CallableFunction): void => {
    let currentLocation: Record<string, string>;
    if (window.BMap) {
      const geolocation = new window.BMap.Geolocation();

      geolocation.getCurrentPosition(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (r: any) => {
          if (geolocation.getStatus() === 0) {
            const point = new window.BMap.Point(r.point.lng, r.point.lat);
            const geoc = new window.BMap.Geocoder();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            geoc.getLocation(point, (rs: any) => {
              currentLocation = {
                address: rs.address,
              };
              callback(currentLocation);
            });
          } else {
            window.alert('Please enable geolocation in your browser settings.');
          }
        },
        { enableHighAccuracy: true }
      );
    }
  };
  const clickHandler = (e: SyntheticEvent): void => {
    e.preventDefault();
    const locationHandler = (data: Record<string, string>): void => {
      const currentLocationInfo = data;
      // update the hidden input fields and destination input field
      currentLocationHiddenFieldHandler(currentLocationInfo);
      inputFieldHandler(currentLocationInfo['address']);
    };
    getCurrentLocationBaidu(locationHandler);
  };

  useEffect(() => {
    // const { BAIDU_MAP_API_KEY } = process.env;
    const BAIDU_MAP_API_KEY = envVarsObject?.['BAIDU_MAP_API_KEY'];
    if (!window.BMap || window.BMap === undefined) {
      appendMapFile();
    }

    function appendMapFile() {
      const script = document.createElement('script');
      script.src = `https://api.map.baidu.com/getscript?v=3.0&ak=${BAIDU_MAP_API_KEY}&s=1`;
      script.defer = true;
      document.head.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });
  return (
    <StyledCurrentLocation>
      <a
        href="#"
        onTouchStart={(event: SyntheticEvent): void => clickHandler(event)}
        onClick={(event: SyntheticEvent): void => clickHandler(event)}
        className="t-subtitle-m"
      >
        <span className="icon-nearby">{currentLocationLabel}</span>
      </a>
    </StyledCurrentLocation>
  );
};

export default CurrentLocationBaidu;
